module.exports = __webpack_public_path__ + "img/alertas-generadas-en-el-sistema.c7f03c9f.svg";